export default __webpack_public_path__ + "images/0x2260fac5e5542a773aa44fbcfedf7c193bc2c599.png";